import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/linkedin-summary-generator/LinkedInSummaryContent.tsx");
